import { useEffect, useMemo, useState } from 'react';
import type { NFLGameInputs } from '@library/types/simulations';
import { NumberInput } from '@library/components/inputs';

export const GameNumberOverride = ({
  currentValue,
  field,
  onBlur,
  onSetGameOverrides
}: {
  currentValue: number | '';
  field: keyof NFLGameInputs;
  onBlur: (field: keyof NFLGameInputs) => void;
  onSetGameOverrides: (field: keyof NFLGameInputs, value: number | '') => void;
}) => {
  const handleChangeNumber = useMemo(
    () => (inputValue: string) => {
      onSetGameOverrides(
        field,
        inputValue !== '' ? Number(inputValue) : inputValue
      );
    },
    [field, onSetGameOverrides]
  );

  const [value, setValue] = useState<string>(String(currentValue));

  useEffect(() => {
    if (String(currentValue) !== value) {
      handleChangeNumber(value);
    }
  }, [currentValue, handleChangeNumber, value]);

  return (
    <NumberInput
      className="font-heebo text-soClean-100 disabled:text-soClean-160 border-soFresh-140 h-8 w-16 rounded-md bg-transparent px-0 text-center text-sm font-medium leading-5 tracking-tight"
      onBlur={() => onBlur(field)}
      onValueChange={(inputValue) => setValue(inputValue)}
      value={value}
    />
  );
};
